import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
/**
 * Port of detail_behavior expand button.
 *
 * @example
 * <expand-button>
 *   <template #expanded>
 *      Text goes here.
 *    </template>
 * </expand-button>
 */ export default {
    name: 'ExpandButton',
    components: {
        GlButton
    },
    data () {
        return {
            isCollapsed: true
        };
    },
    computed: {
        ariaLabel () {
            return __('Click to expand text');
        }
    },
    destroyed () {
        this.isCollapsed = true;
    },
    methods: {
        onClick () {
            this.isCollapsed = !this.isCollapsed;
        }
    }
};
